import api from "../utils/api";
import { isGuid } from "../utils/string";

import { LOGOUT } from "./types";

export const get = ({ uuid }) => async (dispatch) => {
    try {
        const res = isGuid(uuid) ? await api.get(`/addresses/i/${uuid}`) : { data: { success: false }} ;
        return res.data?.item ?? res.data;
    } catch (err) {
        dispatch({
            type: LOGOUT
        });
    }
}

export const save = ({ uuid, line1, line2, city, state, county, zipCode, country }) => async (dispatch) => {
    try {
        const res = isGuid(uuid) ? await api.post(`/addresses`, {
            uuid,
            line1,
            line2,
            city,
            state,
            county,
            zipCode,
            country
        }) : { data: { success: false }} ;
        return res.data;
    } catch (err) {
        dispatch({
            type: LOGOUT
        });
    }
}


export const search = ({ search, page=0, size=10, order="createdAt", direction="ASC" }) => async (dispatch) => {
    try {
        const res = await api.get(`/addresses/p/${page}/s/${size}/o/${order}/${direction}${search ? "/"+search : ""}`);
        return res.data;
    } catch (err) {
        dispatch({
            type: LOGOUT
        });
    }
}
